import {React,useState, useRef} from "react";
import { CProgress, CProgressBar } from "@coreui/react";
import ReCAPTCHA from "react-google-recaptcha";

function Contact() {


    const recaptchaRef = useRef();
    const [captchaValue, setCaptchaValue] = useState("");
    const [verified, setVerified] = useState(false);
    const [nameSurname, setNameSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [progress, setProgress] = useState(100);

    const handleCaptchaChange = (value) => {
        if(value){
            setVerified(true);
            setCaptchaValue(value);
        }
    };

    const handleSubmit = (e) =>{
        e.preventDefault(); //Sayfanın reload olmasını engeller.

        if(!verified){
            alert("Lütfen reCAPTCHA doğrulamasını yapın!");
            return;
        }

        fetch("https://selcukyapicicomtr-backend-1.onrender.com/api/message",
        //fetch("http://localhost:8080/api/message",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    strNameSurname: nameSurname,
                    strEmail: email,
                    strTelNum: phone,
                    strMessage: message,
                    strCaptchaValue: captchaValue,
                }),
            })
            .then((res) => res.json())
            .then((data) => console.log("Server response:", data))
            .catch((err) => console.error(err));

        setNameSurname("");
        setPhone("");
        setEmail("");
        setMessage("");

        setSuccess(true);
        setProgress(100);

        const interval = setInterval(() => {
            setProgress((prev) => {
                if(prev <= 0){
                    clearInterval(interval); // intervali durduruyoruz, artık her 100ms tekrar çalışmayacak
                    setSuccess(false);      // mesajı gizliyoruz
                    return 0;               // progress değerini 0’a ayarlıyoruz
                }
                return prev - 2;           // progress’i her 100ms 2 azaltıyoruz
            });
        }, 100); // her 100ms çalışacak


        // setTimeout(() => {
        //     setSuccess(false); //5sn sonra başarılı şekilde gönderildi mesajını gizle.
        // },5000);
    };


    return (<>
            <section className="page-section" id="contact">
                <div className="container px-4 px-lg-5">
                    <div className="row gx-4 gx-lg-5 justify-content-center">
                        <div className="col-lg-8 col-xl-6 text-center">
                            <h2 className="mt-0">Gelin Tanış Olalım!</h2>
                            <hr className="divider"/>
                            <p className="text-muted mb-5">Yeni bir projeye başlamak için hazırız. Bize bir mesaj gönderin ve size olabilidiğince hızlı cevap verelim.</p>
                        </div>
                    </div>
                    <div className="row gx-4 gx-lg-5 justify-content-center mb-5">
                        <div className="col-lg-6">
                            {/** * * * * * * * * * * * * * **/}
                            {/** * SB Forms Contact Form * **/}
                            {/** * * * * * * * * * * * * * **/}
                            {/*This form is pre-integrated with SB Forms.*/}
                            {/*To make this form functional, sign up at*/}
                            {/*https://startbootstrap.com/solution/contact-forms*/}
                            {/*to get an API token!*/}
                            <form id="contactForm" data-sb-form-api-token="API_TOKEN" onSubmit={handleSubmit}>
                                {/*Name input*/}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="name" type="text"
                                           placeholder="Enter your name..." data-sb-validations="required" value={nameSurname} onChange={(e) => setNameSurname(e.target.value)}/>
                                    <label htmlFor="name">Adınız ve soyadınız</label>
                                    <div className="invalid-feedback" data-sb-feedback="name:required">A name is
                                        required.
                                    </div>
                                </div>
                                {/*Email address input*/}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="email" type="email"
                                           placeholder="name@example.com" data-sb-validations="required,email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                                    <label htmlFor="email">E-posta adresiniz</label>
                                    <div className="invalid-feedback" data-sb-feedback="email:required">An email is
                                        required.
                                    </div>
                                    <div className="invalid-feedback" data-sb-feedback="email:email">Email is not
                                        valid.
                                    </div>
                                </div>
                                {/*Phone number input*/}
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="phone" type="tel" placeholder="(123) 456-7890"
                                           data-sb-validations="required" value={phone} onChange={(e) => setPhone(e.target.value)}/>
                                    <label htmlFor="phone">Telefon numaranız</label>
                                    <div className="invalid-feedback" data-sb-feedback="phone:required">A phone number
                                        is required.
                                    </div>
                                </div>
                                {/*Message input*/}
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control"
                                        id="message"
                                        type="text"
                                        placeholder="Enter your message here..."
                                        style={{height: "10rem"}}
                                        data-sb-validations="required" value={message} onChange={(e) => setMessage(e.target.value)}>
</textarea>

                                    <label htmlFor="message">Mesajınız</label>
                                    <div className="invalid-feedback" data-sb-feedback="message:required">A message is
                                        required.
                                    </div>
                                </div>
                                {/*Submit success message*/}
                                {/*This is what your users will see when the form*/}
                                {/*has successfully submitted*/}
                                {success && (
                                    <div
                                        style={{
                                            position: "fixed",
                                            bottom: "20px",
                                            right: "20px",
                                            width: "250px",
                                            zIndex: 9999,
                                        }}
                                    >
                                        <CProgress className={"mb-2"}>
                                            <CProgressBar
                                                color={"success"}
                                                variant={"striped"}
                                                animated
                                                value={progress}
                                            />
                                        </CProgress>
                                        <div id="submitSuccessMessage">
                                            <div className="text-center mb-3">
                                                <div className="fw-bolder">Mesajınız başarılı şekilde gönderildi!</div>
                                            </div>
                                        </div>

                                    </div>
                                )}


                                {/*Submit error message*/}

                                {/*This is what your users will see when there is*/}
                                {/*an error submitting the form*/}
                                <div className="d-none" id="submitErrorMessage">
                                    <div className="text-center text-danger mb-3">Error sending message!</div>
                                </div>
                                <div className="d-grid">
                                    <ReCAPTCHA
                                        sitekey={"6LfhLPQrAAAAAJa9DMDoBSgW8G_G9CfbIAmIAhuV"}
                                        onChange={handleCaptchaChange}
                                        ref={recaptchaRef}/>
                                </div>
                                {/*Submit Button*/}
                                <div className="d-grid">
                                    <button disabled={!verified} className="btn btn-primary btn-xl" id="submitButton"
                                            type="submit">Gönder
                                    </button>
                                </div>

                            </form>
                        </div>
                    </div>
                    <div className="row gx-4 gx-lg-5 justify-content-center">
                        <div className="col-lg-4 text-center mb-5 mb-lg-0">
                            <i className="bi-phone fs-2 mb-3 text-muted"></i>
                            {/*<div></div> buraya telefon numarası gelecek.*/}
                        </div>
                    </div>
                </div>
            </section>
        </>);
}

export default Contact;